import React from 'react';
import OfficeMultiChoice from './OfficeMultiChoice';
import OfficeService from '../../../../../Services/OfficeService';
import ErrorMessage from '../../../../ErrorMessage';

export default class OfficeForReportMultiSelect extends React.Component {
  static defaultProps = {
    onChange: () => {},
    selected: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      itemList: [],
      autoSelected: false,
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selected !== this.props.selected) {
      this.populateListData();
    }
  }

  populateListData() {
    OfficeService.GetOfficesByReportRole()
      .then((result) => {
        const optValues = [];
        result.forEach((office) => {
          optValues.push({
            label: office.name,
            value: office.officeId,
            disabled: false,
          });
        });
        this.setState({ itemList: optValues });
        // on the first load, if placeholder is 'select_all' and nothing is selected, select all offices
        if (
          this.props.placeholder === 'select_all' &&
          (!this.props.selected || this.props.selected.length === 0) &&
          optValues.length > 0 &&
          !this.state.autoSelected
        ) {
          this.setState({ autoSelected: true }, () => {
            this.props.onChange(optValues.map((o) => o.value));
          });
        }
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('OFRMS44');
      });
  }

  render() {
    return (
      <OfficeMultiChoice
        selected={this.props.selected}
        onChange={this.props.onChange}
        customOfficeList={this.state.itemList}
      />
    );
  }
}
